module.exports = __webpack_public_path__ + "static/member-8c22472a0bc3b1264cefc1d0cfc34428.jpg";